import React, { useContext, useEffect } from "react";
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from "chart.js";
import { useTranslation } from "react-i18next";
import { Doughnut } from "react-chartjs-2";
import { SocketContext } from "../../context/SocketContext";
import { SSignal } from "./Charts.style";

ChartJS.register(ArcElement, Tooltip, Legend);

const SyncDonutGraph = ({ legend = false, fuzzy = true }) => {
  const { t } = useTranslation("", { keyPrefix: "components.charts" });

  const { globalUnderstanding } = useContext(SocketContext);
  const alpha = fuzzy ? "0.2" : "1";

  const areStudentsPresent =
    globalUnderstanding.counters.low + globalUnderstanding.counters.mid + globalUnderstanding.counters.high > 0;

  const data = {
    labels: [t("not_clear"), t("half_clear"), t("clear")],
    datasets: [
      {
        label: t("students_understanding"),
        data: [globalUnderstanding.counters.low, globalUnderstanding.counters.mid, globalUnderstanding.counters.high],
        backgroundColor: [
          `rgba(255, 99, 132, ${alpha})`,
          `rgb(255, 205, 86, ${alpha})`,
          `rgba(75, 192, 192, ${alpha})`,
        ],
        borderColor: ["rgba(255, 99, 132, 1)", "rgb(255, 205, 86, 1)", "rgba(75, 192, 192, 1)"],
        borderWidth: 1,
      },
    ],
    text: "A",
  };

  const options = {
    centerText: "👨‍👩‍👧‍👦",
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: legend,
        position: "right",
      },
      title: {
        display: false,
      },
    },
  };

  const plugs = [
    {
      id: "centertext",
      beforeDraw: function (chart) {
        if (chart.options.centerText) {
          var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;

          ctx.restore();
          var fontSize = (height / 80).toFixed(2); // was: 114
          ctx.font = "bold " + fontSize + "em sans-serif";
          ctx.textBaseline = "middle";

          var text = chart.options.centerText, // "75%",
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2 - chart.titleBlock.height;

          ctx.fillText(text, textX, textY);
          ctx.save();
        }
      },
    },
  ];

  return (
    <>
      {areStudentsPresent ? (
        <Doughnut className="blink" height="100%" data={data} options={options} plugins={plugs} />
      ) : (
        <Signal />
      )}
    </>
  );
};

const Signal = () => {
  useEffect(() => {
    const textRed = document.querySelector(".text-blue");
    if (textRed) textRed.innerHTML = textRed.textContent.replace(/\S/g, '<span class="text-letter"> $&</span>');

    const element = document.querySelectorAll(".text-letter");
    for (let i = 0; i < element.length; i++) {
      element[i].style.transform = "rotate(" + i * 15 + "deg)";
    }
  }, []);

  return (
    <SSignal>
      <section className="signal">
        <h2 className="text text-blue">........................ </h2>
        <h1>
          <i className="fas fa-users" />
        </h1>
      </section>
    </SSignal>
  );
};

export default SyncDonutGraph;
